import React, { useState } from 'react';
import PopOver from './Popover';
import Shortcut from './Shortcut';
import { ItemsList } from './Dropdown';
import { SectionedListBox } from './common/SectionedListBox';
import { UnSectionedListBox } from './common/UnSectionedListBox';

export const ListboxWrapper = ({ children, border }) => {
  return (
    <div
      className={`w-full border-small px-1 py-2 rounded-large ${
        border ? 'border-default-200 dark:border-default-100' : 'border-none'
      }`}
    >
      {children}
    </div>
  );
};

export interface ListBoxProps {
  itemsList: ItemsList;
  itemStyleClasses?: string | undefined;
  closeDropdown: () => void;
  border: boolean;
  showPopover?: boolean | undefined;
  setShowPopover?: (state: boolean) => void;
  showTooltip?: boolean | undefined;
}
interface DropdownListBoxProps {
  sectioned: boolean;
  itemsList: ItemsList;
  itemStyleClasses?: string | undefined;
  closeDropdown: () => void;
  showPopover?: boolean | undefined;
  setShowPopover?: (state: boolean) => void;
  border: boolean;
  showTooltip?: boolean | undefined;
}

const defaultProps = {
  showPopover: undefined,
  setShowPopover: () => {},
  itemStyleClasses: '',
  showTooltip: false,
};

export const listBoxSlotStyles = {
  listbox: {
    list: '!p-0 m-0 list-none [&>*:last-child]:!m-0',
  },
  listboxSection: {
    group: '!p-0 list-none',
  },
  popoverContent: {
    list: '!p-0 m-0 list-none',
    content: '!p-0',
  },
  lisboxItem: {
    base: 'gap-[12px]',
  },
};

export const getEndContent = (
  endIcon,
  shortcut,
  item,
  closeDropdown,
  showPopover,
) => {
  const { hasPopover, popoverData, sectioned } = item;
  let content;
  if (hasPopover && popoverData) {
    if (sectioned) {
      content = (
        <SectionedListBox
          itemsList={popoverData}
          closeDropdown={closeDropdown}
          border={false}
        />
      );
    } else {
      content = (
        <UnSectionedListBox
          itemsList={popoverData}
          closeDropdown={closeDropdown}
          border={false}
        />
      );
    }
    return <PopOver content={content} isOpen={showPopover} />;
  }
  if (endIcon && shortcut) {
    return (
      <>
        {endIcon}
        <Shortcut>{shortcut}</Shortcut>
      </>
    );
  }
  if (endIcon) {
    return endIcon;
  }
  if (shortcut) {
    return <Shortcut>{shortcut}</Shortcut>;
  }
  return null;
};

const DropdownListBox: React.FC<DropdownListBoxProps> = ({
  sectioned,
  border,
  ...props
}) => {
  const [showPopover, setShowPopover] = useState(false);

  return sectioned ? (
    <SectionedListBox
      {...props}
      border={border}
      showPopover={showPopover}
      setShowPopover={setShowPopover}
    />
  ) : (
    <UnSectionedListBox
      {...props}
      border={border}
      showPopover={showPopover}
      setShowPopover={setShowPopover}
    />
  );
};

SectionedListBox.defaultProps = defaultProps;
UnSectionedListBox.defaultProps = defaultProps;
DropdownListBox.defaultProps = defaultProps;

export default DropdownListBox;
